import { Epic } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, withLatestFrom, filter } from 'rxjs/operators';

import { RootState } from '../../../store';
import {
  apiOnWidgetFetchData,
  apiOnWidgetFetchDataFailed,
  apiViewUpdateData,
} from '../apiSlice';

const apiOnWidgetFetchDataAction = apiOnWidgetFetchData<any>();
type IN = ReturnType<typeof apiOnWidgetFetchDataAction>;
type OUT =
  | ReturnType<typeof apiViewUpdateData>
  | ReturnType<typeof apiOnWidgetFetchDataFailed>;

export const ApiOnWidgetFetchDataEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(apiOnWidgetFetchDataAction.match),
    withLatestFrom(state$),
    mergeMap(([{ payload }, state]) => {
      const { service, filters, dataKey } = payload;
      if (!service)
        return [
          apiOnWidgetFetchDataFailed({ msg: 'Failed to obtain access token' }),
        ];

      return from(
        service(filters)
          .then((data) => apiViewUpdateData([dataKey, data]))
          .catch((error) => {
            console.error(error);
            return apiOnWidgetFetchDataFailed({
              msg: 'Failed to fetch user',
            });
          }),
      );
    }),
  );
